import PendingActionsIcon from '@mui/icons-material/PendingActions'
import { IconButton, Tooltip } from '@mui/material'
import { useContext, useState } from 'react'

import { RepairOrderContext } from '../../../providers/RepairOrderProvider/RepairOrderProvider'
import MaintenanceScheduleDialog from './MaintenanceScheduleDialog'
import { MaintenanceScheduleProvider } from './MaintenanceScheduleProvider'

export const MaintenanceScheduleButton = () => {
  const [open, setOpen] = useState(false)
  const { vehicle, repairOrder } = useContext(RepairOrderContext)
  const vehicleIsCustom =
    vehicle?.info!.make?.id === undefined ||
    vehicle?.info.model?.id === undefined ||
    vehicle?.info.subModel?.id === undefined ||
    vehicle?.info.engine?.id === undefined

  if (vehicleIsCustom) {
    return (
      <Tooltip title="MOTOR Maintenance Schedules are unavailable for custom vehicles">
        <span>
          <IconButton disabled>
            <PendingActionsIcon />
          </IconButton>
        </span>
      </Tooltip>
    )
  }
  return (
    <>
      <MaintenanceScheduleProvider
        vehicleId={vehicle?.id}
        defaultMiles={repairOrder?.entry!.info!.mileageIn}>
        {open && (
          <MaintenanceScheduleDialog handleClose={() => setOpen(false)} />
        )}
      </MaintenanceScheduleProvider>
      <Tooltip title="MOTOR Maintenance Schedules">
        <IconButton onClick={() => setOpen(true)}>
          <PendingActionsIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}
